import React from "react";

export default function IconNextProfile() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="flex items-center w-5 h-5"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M9 5l7 7-7 7"
      />
    </svg>
  );
}
